import { FileManaged } from '../structures/response/FileManaged';
import apiClient from './apiClient';

export const signQualified = async (
  fileId: number | string,
  signature: string
): Promise<FileManaged> =>
  apiClient
    .post('esign/api/qualified', { fileId, signature })
    .then((r) => r.data);

export const signSms = async (
  fileId: number,
  code: string
): Promise<FileManaged> =>
  apiClient.post('esign/api/simple', { fileId, code }).then((r) => r.data);
